import { render, staticRenderFns } from "./feedbackAdmin.vue?vue&type=template&id=925c7264&scoped=true"
import script from "./feedbackAdmin.vue?vue&type=script&lang=js"
export * from "./feedbackAdmin.vue?vue&type=script&lang=js"
import style0 from "./feedbackAdmin.vue?vue&type=style&index=0&id=925c7264&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925c7264",
  null
  
)

export default component.exports